import React from 'react';
import { motion } from 'framer-motion';
import { cvData } from '../data/cvData';
import { uiTranslations } from '../data/translations';
import { useLanguage } from '../context/LanguageContext';
import SectionHeader from './SectionHeader';

export default function Skills() {
  const { language } = useLanguage();
  const data = cvData[language];
  const t = uiTranslations[language].sections.skills;
  const labels = uiTranslations[language].skills;

  if (!data.skills || data.skills.length === 0) return null;

  return (
    <section id="skills" className="py-24 bg-surface">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <SectionHeader title={t.title} label={t.label} />
        <div className="columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8">
          {data.skills.map((skillGroup, index) => (
            <motion.div key={index} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: index * 0.1 }} className="break-inside-avoid mb-8 bg-white p-8 rounded-lg shadow-sm border border-slate-100 hover:shadow-md transition-shadow duration-300">
              <h3 className="text-lg font-semibold text-slate-900 mb-6 pb-2 border-b border-slate-100">
                {skillGroup.category}
              </h3>
              <ul className="space-y-3">
                {skillGroup.items.map((item, idx) => (
                  <li key={idx} className="flex items-start text-slate-600">
                    <span className="w-1.5 h-1.5 bg-primary rounded-full mt-2.5 mr-3 flex-shrink-0"></span>
                    <span className="leading-relaxed text-[15px]">{item}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mt-16 pt-10 border-t border-slate-200/60 flex flex-col md:flex-row justify-between items-center gap-8 md:gap-16">
          <div className="flex-1 text-center md:text-left">
            <h4 className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-2">{labels.languages}</h4>
            <p className="text-base text-slate-500 font-medium tracking-tight">
              {data.personal.languages}
            </p>
          </div>
          <div className="hidden md:block w-px h-10 bg-slate-200"></div>
          <div className="flex-1 text-center md:text-left">
            <h4 className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-2">{labels.misc}</h4>
            <p className="text-base text-slate-500 font-medium tracking-tight">
              {data.personal.misc}
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}